<template>
  <div @click.self="closeModal" class="modalContainer">
    <div id="modalWrapper" class="modalWrapper">
      <div @click="closeModal" class="close">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.1161 6.6228L7.75908 6.97635L8.11437 7.33163L13.4572 12.6745L12.6745 13.4572L11.8466 12.6294L11.8449 12.6277L7.37718 8.11608L7.02364 7.75906L6.66835 8.11435L1.32551 13.4572L0.542786 12.6745L5.88563 7.33163L6.24062 6.97664L5.8842 6.62309L0.543158 1.32514L1.32551 0.542787L6.66835 5.88563L7.02334 6.24061L7.37689 5.88419L12.6748 0.543155L13.4572 1.32551L12.6294 2.15333L12.6277 2.15504L8.1161 6.6228ZM12.7648 13.5475C12.7649 13.5476 12.765 13.5478 12.7651 13.5479L12.7648 13.5475ZM0.452113 12.7651L0.452145 12.7651C0.452134 12.7651 0.452123 12.7651 0.452113 12.7651Z"
            fill="black"
            stroke="black"
          />
        </svg>
      </div>
      <h2 style="text-align: center">Complete Account Info</h2>
      <div
        v-if="!customerData.first_name || customerData.first_name == '' || customerData.first_name == ' '"
        class="inputWrapper"
      >
        <label for="email">First Name</label>
        <input
          @keyup.enter="save"
          v-model="first_name"
          type="text"
          @input="formatNameWhileTyping(first_name)"
          placeholder="First Name"
          id="first_name"
        />
        <p v-if="v$.first_name.$error === true" class="validation">Please enter your first name</p>
      </div>
      <div
        v-if="!customerData.last_name || customerData.last_name == '' || customerData.last_name == ' '"
        class="inputWrapper"
      >
        <label for="email">Last Name</label>
        <input
          @keyup.enter="save"
          v-model="last_name"
          type="text"
          @input="formatLastNameWhileTyping(last_name)"
          placeholder="Last Name"
        />
        <p v-if="v$.last_name.$error === true" class="validation">Please enter your last name</p>
      </div>
      <div v-if="!customerData.phone || customerData.phone == ''" class="inputWrapper">
        <label for="phone">Cell Phone Number</label>
        <input
          @keyup.enter="save"
          @input="formatPhoneNumberWhileTyping(phone)"
          v-model="phone"
          type="text"
          placeholder="Cell Phone Number"
          id="phone"
          inputmode="tel"
        />
        <p v-if="v$.phone.$error === true" class="validation">Please enter your cell phone number</p>
        <p v-if="validPhoneNumberError" class="validation" data-cy="phone-validation-error">
          Please enter a valid phone number. Phone number can't start with 0 or 1
        </p>
        <p class="info">To verify your account, we'll send a 6 digit code via SMS to this number.</p>
      </div>
      <p class="feedback error" v-if="error.status">{{ error.message }}</p>
      <button @click="save" :disabled="buttonLoader">
        <div v-if="buttonLoader" class="loader buttonLoader"></div>
        <template v-if="!buttonLoader">SAVE</template>
      </button>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { requiredIf } from '@vuelidate/validators'

import { mapState, mapMutations } from 'vuex'

import modalMixins from '@/mixins/modalMixins.js'
import formattingMixins from '@/mixins/formattingMixins'

import customersApi from '@/api/customersApi.js'

export default {
  setup() {
    return {
      v$: useVuelidate(),
    }
  },
  data() {
    return {
      first_name: '',
      last_name: '',
      phone: '',
      error: {
        status: false,
        message: '',
      },
      validPhoneNumberError: false,
    }
  },
  validations() {
    return {
      first_name: {
        requiredIf: requiredIf(() => !this.customerData.first_name || this.customerData.first_name == ' '),
      },
      last_name: { requiredIf: requiredIf(() => !this.customerData.last_name || this.customerData.last_name == ' ') },
      phone: {
        requiredIf: requiredIf(() => !this.customerData.phone || this.customerData.phone == ''),
      },
    }
  },
  mixins: [modalMixins, formattingMixins],
  computed: {
    ...mapState(['buttonLoader', 'branding', 'cookies', 'customerData']),
  },
  methods: {
    ...mapMutations(['SET_BUTTON_LOADER', 'SET_CUSTOMER_DATA', 'SET_TOASTER', 'SET_COOKIES']),
    closeModal() {
      console.log(this.customerData.first_name)
      console.log(this.customerData.last_name)
      this.$emit('closeModal')
    },
    save() {
      this.v$.$touch()
      if (this.v$.$error) {
        console.log('1')
        return
      }
      if (!this.isValidPhoneNumber(this.phone)) {
        this.validPhoneNumberError = true
        console.log('2')
        return
      }
      this.validPhoneNumberError = false
      this.SET_BUTTON_LOADER(true)
      let payload = {
        first_name: this.first_name,
        last_name: this.last_name,
        phone: this.phone,
        email_optin: true,
        email: this.customerData.email,
      }
      if (this.customerData.first_name && this.customerData.first_name !== ' ') {
        payload.first_name = this.customerData.first_name
      }
      if (this.customerData.last_name && this.customerData.last_name !== ' ') {
        payload.last_name = this.customerData.last_name
      }
      if (this.customerData.phone && this.customerData.phone != '') {
        payload.phone = this.customerData.phone
      }
      let customerId = this.customerData.customer_id
      customersApi
        .updateCustomer(payload, customerId)
        .then((response) => {
          this.SET_CUSTOMER_DATA(response.data.data)
          this.$emit('closeModal')
          this.SET_BUTTON_LOADER(false)
          this.SET_COOKIES(response.data.cookies)
          let toasterData = {
            show: true,
            message: 'Changes saved',
          }
          if (!response.data.data.is_phone_verified) {
            this.$emit('openVerifyPhoneModal')
          }
          if (!response.data.data.is_verified) {
            this.$emit('openVerifyEmailModal')
          }
          this.SET_TOASTER(toasterData)
          this.$emit('confirmedMissingInfo')
        })
        .catch((error) => {
          console.log(error)
          this.SET_BUTTON_LOADER(false)
          this.error.status = true
          this.error.message = error.response.data.data.error
        })
    },
  },
}
</script>

<style src="../../../assets/css/Modals/AuthenticationModals/MissingInfoModal.css" scoped></style>
